import { APIEndpoint } from ".";

// Create a new account
export const uploadImage = async (file: File) => {
  const formData = new FormData();
  formData.append("file", file);

  return fetch(`${APIEndpoint}/assets/upload`, {
    method: "POST",
    headers: {
      Authorization: localStorage.getItem("token"),
    },
    body: formData,
  })
    .then((response) => response.json())
    .catch((error) => console.error("Error uploading image:", error));
};

export const generateImageForBlogArticle = async (prompt: string) => {
  return fetch(`${APIEndpoint}/assets/image`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ prompt }),
  })
    .then((response) => response.text())
    .catch((error) => console.error("Error generating image:", error));
};

export const generateArticleForBlog = async (prompt: string) => {
  return fetch(`${APIEndpoint}/assets/article`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      authorization: `${localStorage.getItem("token")}`,
    },
    body: JSON.stringify({ prompt }),
  })
    .then((response) => response.json())
    .catch((error) => console.error("Error generating image:", error));
};
